module.exports = __webpack_public_path__ + "static/img/Gold Nova III.4f6d1d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Gold Nova III.png
// module id = 0I7L
// module chunks = 35